"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fetchProductEpic = void 0;

var _utils = require("@alycecom/utils");

var _operators = require("rxjs/operators");

var _queryString = _interopRequireDefault(require("query-string"));

var _services = require("@alycecom/services");

var _products = require("./products.actions");

var fetchProductEpic = function fetchProductEpic(action$, state$, _ref) {
  var apiService = _ref.apiService;
  return action$.pipe((0, _utils.ofType)(_products.fetchProduct.pending), (0, _operators.mergeMap)(function (_ref2) {
    var _ref2$payload = _ref2.payload,
        id = _ref2$payload.id,
        denomination = _ref2$payload.denomination;
    var query = denomination !== null ? _queryString.default.stringify({
      denomination
    }) : '';
    return apiService.get("/api/v1/marketplace/products/".concat(id, "?").concat(query), null, true).pipe((0, _operators.map)(function (response) {
      return _products.fetchProduct.fulfilled(response.data);
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_products.fetchProduct.rejected()))));
  }));
};

exports.fetchProductEpic = fetchProductEpic;
var _default = [fetchProductEpic];
exports.default = _default;